module.exports = __webpack_public_path__ + "img/OBCINA SKOFJA LOKA.06cee6d2.png";